import clsx from 'clsx';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

import { Button } from '~modules/media-library/view/Button';

export const TeaserMenuItemButton = forwardRef<
  ComponentRef<typeof Button>,
  Omit<ComponentPropsWithoutRef<typeof Button>, 'variant'> & { focus?: boolean }
>(function TeaserMenuItemButton({ children, focus = false, className = '', ...ButtonProps }, ref) {
  return (
    <Button
      variant="ghost"
      className={clsx('ml--teaser-menu--item', focus && 'underline', className)}
      {...ButtonProps}
      ref={ref}
    >
      {children}
    </Button>
  );
});
